import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetUnitsListSlice = createSlice({
    name: "getUnitsList",
    initialState,
    reducers: {
        getUnitsListRequest(state) {
            state.loading = true;
        },
        getUnitsListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getUnitsListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getUnitsListRequest,
    getUnitsListRequestSuccess,
    getUnitsListRequestError,
} = GetUnitsListSlice.actions;

export default GetUnitsListSlice.reducer;
